// src/analytics.js
export const trackPageView = (url) => {
    const trackId = process.env.REACT_APP_GA_TRACKING_ID;
    if (window.gtag) {
        window.gtag("config", trackId, {
            page_path: url,
        });
    }
};
